import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import styles from '../NewUserWizard.module.css';

const StepAfterConnect = ({ onNext }) => {
  const { t } = useLanguage();
  const [visibleItems, setVisibleItems] = useState([]);

  const timeline = [
    {
      emoji: '🔄',
      bg: '#eff8ff',
      title: t('step3Item1Title', 'Reviews are fetched'),
      desc: t('step3Item1Desc', 'We pull your latest Google reviews every few hours automatically — no manual effort needed.'),
    },
    {
      emoji: '🤖',
      bg: '#faf5ff',
      title: t('step3Item2Title', 'AI drafts a reply'),
      desc: t('step3Item2Desc', 'Our AI crafts a personalised, brand-matched reply for each new review based on your tone settings.'),
    },
    {
      emoji: '📧',
      bg: '#fffbeb',
      title: t('step3Item3Title', 'You get an email'),
      desc: t('step3Item3Desc', 'We send you a summary email with each draft reply for your review and approval.'),
    },
    {
      emoji: '✅',
      bg: '#f0fdf4',
      title: t('step3Item4Title', 'Reply goes live'),
      desc: t('step3Item4Desc', 'One click in the email approves and publishes the reply directly to your Google Business Profile.'),
    },
  ];

  useEffect(() => {
    timeline.forEach((_, i) => {
      setTimeout(() => {
        setVisibleItems(prev => [...prev, i]);
      }, i * 280);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className={styles.stepTag}>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
        </svg>
        {t('step3Tag', 'How it works')}
      </div>

      <h2 className={styles.wizardTitle}>{t('wizardStep3Title', "Here's what happens next")}</h2>
      <p className={styles.wizardSubtitle}>
        {t('step3Sub', 'Once connected, this automated flow runs every few hours on your behalf:')}
      </p>

      <div className={styles.timeline}>
        {timeline.map((item, i) => (
          <div
            key={i}
            className={`${styles.timelineItem} ${visibleItems.includes(i) ? styles.timelineItemVisible : ''}`}
          >
            <div className={styles.timelineLeft}>
              <div className={styles.timelineIconWrap} style={{ background: item.bg }}>
                {item.emoji}
              </div>
              {i < timeline.length - 1 && <div className={styles.timelineLine} />}
            </div>
            <div className={styles.timelineContent}>
              <div className={styles.timelineTitle}>{item.title}</div>
              <div className={styles.timelineDesc}>{item.desc}</div>
            </div>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
        <button type="button" className={styles.btnPrimary} onClick={onNext}>
          {t('step3Cta', 'Got it, show me the dashboard')}
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M5 12h14" /><path d="m12 5 7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default StepAfterConnect;
